import React, { Component } from "react";
import { connect } from 'react-redux';
import { logoutApp } from '../../redux/actions/app';
import Detail from '../components/Detail.jsx';
import Language from './Language.jsx';
import { withTranslation  } from 'react-i18next';

export class Header extends Component {
  constructor(props){
    super(props);
    // console.log('containers/Header.jsx - 61 ==> props', props);
    this.state = {
      details: [0, 0, 0, 0],
      orders: props.orders.items,
      groupedOrders: props.groupedOrders
    };
    // console.log('containers/Header.jsx - 65 ==> details', this.state.details);
  }

  async componentWillReceiveProps(nextProps) {
    console.log('containers/Header.jsx - 69 ==> nextProps', nextProps);
    let tempState = this.state;
    if(nextProps.orders.items && nextProps.orders.items.length > 0) {
      tempState.groupedOrders = this.groupByOrderId(nextProps.orders.items);
      tempState.details[0] = tempState.groupedOrders.length;
      tempState.details[1] = nextProps.orders.items.length;
      nextProps.orders.wonderland_points ? tempState.details[2] = nextProps.orders.wonderland_points : tempState.details[2] = 0;
      // tempState.details[2] = nextProps.orders.wonderland_points;
      tempState.details[3] = nextProps.credits.length;
      this.setState(tempState);
    }
    // console.log('containers/Header.jsx - 80 ==> this.state', this.state);
  }

  // TODO: Switch to redux to avoid duplicate with Board component function
   /**
   * @name groupByOrderId
   * @description Loops through array of objects to create a new one where products are grouped by order ID
   * @param {Array} orders Array of objects
   * @returns {Array} groupedOrders Array of objects updated
   */
    groupByOrderId(orders) {
      let groupedOrders = [];
      // Initializing with array's firt order values
      let subOrderGroup = {
        order_id: orders[0].order_id,
        product_list: [orders[0]]
      };

      orders.forEach((order) => {

        if(!order.order_id) {
          // throw new Error(`From src/js/containers/Board.jsx --> The order ${order} does not have an order_id.`);
          console.log('Skipped order: ');
          console.log(order);
          return;
        }
        // Check if oder_id already exists in the groupedOrders array.
        // eslint-disable-next-line
        const foundObject = groupedOrders.find((object, index) => {
          if (object.order_id === order.order_id) {
            // Add product's image url
            order['picture_url'] = this.createProductImageUrl(order);
            groupedOrders[index].product_list.push(order);
            return true; // stop searching
          }
        });

        if(!foundObject) {
          order['picture_url'] = this.createProductImageUrl(order);
          // Re-initialize
          subOrderGroup = {
            order_id: order.order_id,
            product_list: [order]
          };
          groupedOrders.push(subOrderGroup);
        }
      })
      return groupedOrders;
    }

  // TODO: Switch to redux to avoid duplicate with Board component function
  /**
   * @name createProductImageUrl
   * @description creates the product's image url according to sku number and desired quality and size.
   * @param {Array} product
   * @returns {string} url
   */
   createProductImageUrl(product) {
    const image_width = 350;
    const image_height = 350;
    const quality = 80;
    return 'https://imgcdn.apm-monaco.cn/products-images/' +
      product.product_sku +
      '.jpg?x-oss-process=image/resize,w_' +
      image_width +
      ',h_' +
      image_height +
      '/quality,q_' +
      quality;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="container header">
        <div className="title row">
          <div className="left">
            <h1>{ t('header.OrderHistory') }</h1>
          </div>

          <div className="right">
            <Language />
            <button className="button-secondary uppercase" onClick={() => this.props.dispatch(logoutApp())}>{ t('common.LogoutBtn') }</button>
          </div>

        </div>
        <div className="details row">
          {this.state.details.map((detail, i) => (
            <Detail
              key={i}
              id={i}
              data={this.state.details[i]}
            />
          ))}

        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    credits: state.credits
  }
}

export default connect(
  mapStateToProps
)(withTranslation()(Header));



// WEBPACK FOOTER //
// ./src/js/containers/Header.jsx